import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../common/tostify/Toastifyresponse";

import AddUpdateClient from "./AddUpdateClient";
import Table from "../../common/Table/table";
import {
  createClient,
  updateClient,
  deleteClient,
  getClientDataById,
  resetCreateMessages,
  resetUpdateMessages,
  resetDeleteMessages,
} from "../../../store/slices/client.slice";
import ViewModal from "../../common/viewModal/globalViewModal";
import { getAllClinic } from "../../../store/slices/clinicSlice";
import { getRoleSlice } from "../../../store/slices/roleSlice";
import { getClientType } from "../../../store/slices/clientTypeSlice";
import ShowTostifyMessageAndReset from "../../common/showTostifyMessageAndReset/showTostifyMessageAndReset";

const Client = () => {
  const dispatch = useDispatch();
  const [showModal, setModalVisible] = useState(false);
  const [showDeleteModal, setDeleteModalVisible] = useState(false);
  const [showGlobalViewModal, setShowGlobalViewModal] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [modalAction, setModalAction] = useState(null);
  const [deleteClinic, setDeleteclinic] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [inputError, setInputError] = useState({
    email: false,
    phNumber: false,
    name: false,
  });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const showTostifyMessageAndReset = ShowTostifyMessageAndReset();
  const {
    client,
    createclientUserSuccessMessage,
    createclientUserErrorMessage,
    updateclientUserSuccessMessage,
    updateclientUserErrorMessage,
    deleteclientUserSuccessMessage,
    deleteclientUserErrorMessage,
    loading,
  } = useSelector((state) => state.client);
  const {
    clinicInfo,
    allClinicLists,
    searchMessage,
    currentPage,
    totalPages,
    totalCount,
  } = useSelector((state) => state.clinic);

  const { roles } = useSelector((state) => state.role);
  const { clientTypes } = useSelector((state) => state.clientType);
  const { token } = useSelector((state) => state.auth);
   const [pageLimit, setPageLimit] = useState(10);

const clinicId =clinicInfo?.[0]?.clinicId;

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    phone: "",
    clinicId,
    email: "",
    userType: "",
    role: [],
    clientType: [],
    status: "Active",
    password: "",
  });

  useEffect(() => {
    showTostifyMessageAndReset(
      createclientUserSuccessMessage,
      showToastifySuccess,
      resetCreateMessages
    );
    showTostifyMessageAndReset(
      createclientUserErrorMessage,
      showToastifyError,
      resetCreateMessages
    );
    showTostifyMessageAndReset(
      updateclientUserSuccessMessage,
      showToastifySuccess,
      resetUpdateMessages
    );
    showTostifyMessageAndReset(
      updateclientUserErrorMessage,
      showToastifyError,
      resetUpdateMessages
    );
    showTostifyMessageAndReset(
      deleteclientUserSuccessMessage,
      showToastifySuccess,
      resetDeleteMessages
    );
    showTostifyMessageAndReset(
      deleteclientUserErrorMessage,
      showToastifyError,
      resetDeleteMessages
    );
  }, [
    createclientUserSuccessMessage,
    createclientUserErrorMessage,
    updateclientUserSuccessMessage,
    updateclientUserErrorMessage,
    deleteclientUserSuccessMessage,
    deleteclientUserErrorMessage,
    dispatch,
    showTostifyMessageAndReset,
  ]);
  const { tableStatus } = useSelector((state) => state.tableStatusChange);

  useEffect(() => {
    dispatch(
      getRoleSlice({
        clinicId,
        applicationCustomId: 2,
        status: ["Active"],
        token,
      })
    );
    dispatch(
      getClientType({
        clinicId,
        status: ["Active"],
        token,
      })
    );
  }, [dispatch, token, clinicInfo, tableStatus]);

  const fetchClient = useCallback(
    (page = 1, lim = pageLimit, search = searchValue) => {
      if (clinicId && token) {
        dispatch(
          getAllClinic({
            clinicId,
            status: tableStatus,
            loginRole: "Client",
            token,
            currentPage: page,
            limit: lim,
            name: search || undefined,
          })
        );
      }
    },
    [clinicInfo, token, dispatch, tableStatus, searchValue, pageLimit]
  );
  useEffect(() => {
    fetchClient();
  }, [fetchClient, showModal, showDeleteModal, showGlobalViewModal]);
  const handlePageChange = (page) => {
    fetchClient(page, pageLimit, searchValue);
  };
    const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchClient(1, newLimit, searchValue);
  };

  const tableHead = [
    { title: "Name", key: "name" },
    { title: "Email", key: "email" },
    { title: "Phone", key: "phone" },
    { title: "User Type", key: "userType" },
    { title: "Role", key: "role" },
    { title: "ClientType", key: "clientType" },
    { title: "Status", key: "status" },
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleModal = (action, client = null) => {
    if (action === "create") {
      setFormData({
        id: "",
        name: "",
        phone: "",
        email: "",
        password: "",
        clinicId,
        userType: 7,
        role: client?.role[0]?._id,
        clientType: client?.clientType[0]?._id,
        loginRole: "Client",
        status: "Active",
      });
    } else if (action === "edit" && client) {
      setFormData({
        id: client?._id,
        clinicId,
        name: client?.userId?.name,
        phone: client?.userId?.phone,
        email: client?.userId?.email,
        userType: 7,
        role: client?.role[0]?._id,
        clientType: client?.clientType[0]?._id,
        status: client?.status,
        loginRole: "Client",
      });
    }
    setModalVisible(true);
    setModalAction(action);
  };
  const handleAddOrUpdateAccount = async (e) => {
    e.preventDefault();
    const newRoleId = formData?.role?.map((data) => data.value);
    const newClientTypeId = formData?.clientType?.map((data) => data.value);
    const { name, email, phNumber } = inputError;
    if (name || email || phNumber) {
      return;
    }

    try {
      setSubmitLoading(true);
      if (modalAction === "create") {
        await dispatch(
          createClient({
            ...formData,
            role: newRoleId,
            clinicId,
            clientType: newClientTypeId,
            token,
          })
        );
      } else {
        await dispatch(
          updateClient({
            id: formData?.id,
            clinicId,
            name: formData?.name,
            role: newRoleId,
            clientType: newClientTypeId,
            userType: 7,
            email: formData?.email,
            phone: formData?.phone,
            status: formData?.status,
            loginRole: "Client",
            token,
          })
        );
        fetchClient();
      }
      setModalVisible(false);
      setFormData({
        id: "",
        name: "",
        phone: "",
        email: "",
        userType: "",
        role: [],
        clientType: [],
        status: "Active",
      });
    } catch (error) {
      console.error("Error occurred:", error);
    }
    finally{
      setSubmitLoading(false);
    }
  };

  const handleUpdateStatus = async (status, item) => {
    try {
      const updateData = {
        id: item?.id,
        status: status,
        clinicId,
        token,
      };
      await dispatch(updateClient(updateData));
      if (clinicId) {
        fetchClient();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    fetchClient(1, pageLimit, value);
  };

  const handleShowGlobalViewModal = async (data) => {
    await dispatch(
      getClientDataById({
        id: data?.id,
        clinicId,
        token,
      })
    );
    setShowGlobalViewModal(true);
  };

  const handleEdit = (client) => {
    handleModal("edit", client);
    const newRole = client?.roleList?.map((data) => ({
      value: data?.value,
      label: data?.label,
    }));
    const newClientType = client?.clientTypeList?.map((data) => ({
      value: data?.value,
      label: data?.label,
    }));

    setFormData({
      id: client?.id,
      clinicId: client?.clinicId,
      name: client?.name,
      phone: client?.phone,
      email: client?.email,
      userType: client?.userType,
      role: newRole,
      roleName: client?.roleId,
      clientType: newClientType,
      clientTypeName: client?.clientTypeId,
      status: client?.status,
    });
  };
  const handleDeleteclient = async () => {
    try {
      await dispatch(
        deleteClient({
          id: deleteClinic,
          clinicId,
          token,
        })
      );
      setDeleteModalVisible(false);
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };
  const handleDelete = (Id) => {
    setDeleteclinic(Id.id);
    setDeleteModalVisible(true);
  };

  const handleRoleChange = (item) => {
    const newItem = item || [];
    const filterOption = newItem?.map((data) => ({
      value: data?.value,
      label: data?.label,
    }));
    setFormData({
      ...formData,
      role: filterOption,
    });
  };
  const handleClientTypeChange = (item) => {
    const newItem = item || [];
    const filterOption = newItem?.map((data) => ({
      value: data?.value,
      label: data?.label,
    }));
    setFormData({
      ...formData,
      clientType: filterOption,
    });
  };

  return (
    <div className="container mt-4">
      <Table
        tableHead={tableHead}
        tableBody={
          allClinicLists &&
          allClinicLists?.map((item) => ({
            id: item?._id,
            clinicId: item?.clinicId,
            name: item?.userId?.name,
            email: item?.userId?.email,
            phone: item?.userId?.phone,
            userType: item?.loginRole,
            roleList: item?.role?.map((data) => ({
              value: data?._id,
              label: data?.name,
            })),
            role: item?.role.map((data) => data?.name.toString()).join(", "),
            clientTypeList: item?.clientType?.map((data) => ({
              value: data?._id,
              label: data?.name,
            })),
            clientType: item?.clientType
              .map((data) => data?.name.toString())
              .join(", "),
            status: item.status,
          }))
        }
        addModal={() => handleModal("create")}
        handleEdit={handleEdit}
        searchValue={searchValue}
        handleSearch={handleSearch}
        handleDelete={handleDelete}
        handleDeleteclient={handleDeleteclient}
        errorMessage={searchMessage}
        showStatus={showStatus}
        setShowStatus={setShowStatus}
        handleShowGlobalViewModal={handleShowGlobalViewModal}
        handleUpdateStatus={handleUpdateStatus}
        handleAddBtn={true}
        handleSearchOption={true}
       currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />
      <AddUpdateClient
        showModal={showModal}
        searchValue={searchValue}
        setModalVisible={setModalVisible}
        formData={formData}
        handleChange={handleChange}
        modalAction={modalAction}
        handleAddOrUpdateAccount={handleAddOrUpdateAccount}
        handleRoleChange={handleRoleChange}
        handleClientTypeChange={handleClientTypeChange}
        roles={roles}
        clientTypes={clientTypes}
        setInputError={setInputError}
        setShowNewPassword={setShowNewPassword}
        showNewPassword={showNewPassword}
        submitLoading={submitLoading}
        
      />
      <Modal
        centered
        show={showDeleteModal}
        onHide={() => setDeleteModalVisible(false)}
        size="md"
      >
        <div className="modal-header">
          <h5 className="modal-title">Delete AccountType</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setDeleteModalVisible(false)}
          ></button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to delete this client?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setDeleteModalVisible(false)}
          >
            Close
          </button>
          <button
            type="button"
            className="btn btn-danger"
            onClick={handleDeleteclient}
          >
            Delete
          </button>
        </div>
      </Modal>
      <ViewModal
        showGlobalViewModal={showGlobalViewModal}
        setShowGlobalViewModal={setShowGlobalViewModal}
        modalSize={"lg"}
        titel={tableHead}
        content={{
          id: client?._id,
          name: client?.user?.name,
          email: client?.user?.email,
          phone: client?.user?.phone,
          userType: client?.user?.userType[0]?.type,
          role: client?.roles?.map((role) => role?.name).join(", "),
          clientType: client?.clientTypes
            ?.map((clientType) => clientType?.name)
            .join(", "),
          status: client?.client?.status,
        }}
      />
    </div>
  );
};

export default Client;
